<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col md="4" class="my-1">
          <eb-select
            :options="stockOptions"
            type="text"
            label="label"
            v-model="selectedStock"
            @input="changeDeliveryCentre"
            placeholder="Select Delivery Centre"
          ></eb-select>
        </b-col>
      </b-row>
      <b-tabs v-model="tabIndex">
        <b-tab title="View Stock Demand">
          <div class="animated fadeIn">
            <component-header
              title="View Stock Demand"
              :hasSearch="false"
              :hasRadio="true"
              :disableKey="disableKey"
              @dateRangeEmit="dateRangeStockReport"
              @radioChangeInputEmit="dateRangeStockReport"
              :radioOptions="dayRadioOption"
              :hasReload="false"
              :hasClear="false"
              :hasCreate="false"
            />
            <transition name="fade">
              <b-card
                border-variant="info"
                header-bg-variant="primary"
                header-text-variant="white"
                class="card-wrap"
                style="min-height: 400px"
              >
                <div class="mt-3">
                  <b-table
                    :dark="false"
                    :items="stocksData"
                    :hover="true"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    responsive="sm"
                    id="my-table"
                    :current-page="currentpage"
                    :per-page="perPage"
                    thead-class="header"
                    class="mt-3"
                    show-empty
                    :fields="Columns"
                    :no-border-collapse="true"
                    @filtered="onfilter"
                  >
                    <template slot="empty">
                      <div v-if="isDisableRadio" class="text-center">
                        <span><b>Loading...</b></span>
                      </div>
                      <div v-else class="text-center">No data available.</div>
                    </template>
                    <template slot="ACTION" slot-scope="data">
                      <b-button
                        size="sm"
                        class="mr-2"
                        variant="primary"
                        @click="viewStockdetails(data.item)"
                      >
                        <i class="fa fa-eye"> </i>
                      </b-button>
                    </template>
                  </b-table>
                  <b-pagination
                    style="float: right"
                    v-model="currentpage"
                    :total-rows="filtercount"
                    :per-page="perPage"
                    prev-text="Prev"
                    next-text="Next"
                    aria-controls="myHistory"
                    hide-goto-end-buttons
                  ></b-pagination>
                </div>
              </b-card>
            </transition>
          </div>
        </b-tab>
        <b-tab title="View Stock Status">
          <div class="animated fadeIn">
            <component-header
              title="View Stock Status"
              :hasSearch="false"
              :hasRadio="true"
              :disableKey="disableKey"
              @dateRangeEmit="dateRangeStockStatus"
              @radioChangeInputEmit="dateRangeStockStatus"
              :radioOptions="dayRadioOption"
              :hasReload="false"
              :hasClear="false"
              :hasCreate="false"
            />
            <transition name="fade">
              <b-card
                border-variant="info"
                header-bg-variant="primary"
                header-text-variant="white"
                class="card-wrap"
                style="min-height: 400px"
              >
                <div>
                  <b-table
                    :hover="true"
                    :striped="striped"
                    :fields="ColumnStore"
                    :items="stockStatus"
                    :dark="false"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    responsive="sm"
                    id="my-table"
                    :current-page="currentPage"
                    :per-page="perPage"
                    thead-class="header"
                    class="mt-3 mb-0"
                    show-empty
                    :no-border-collapse="true"
                  >
                  </b-table>
                  <div>
                    <b-col style="display: flex; justify-content: end;">
                      <b-button variant="primary" v-b-toggle.collapse-1>Details</b-button>
                    </b-col>
                  </div>
                </div>
                <div>
                  <b-collapse id="collapse-1" class="mt-2">
                    <b-table
                      :hover="true"
                      :items="stockStatus"
                      :striped="striped"
                      :fields="Column"
                      :dark="false"
                      :bordered="bordered"
                      :small="small"
                      :fixed="fixed"
                      responsive="sm"
                      id="my-table"
                      :current-page="currentPage"
                      :per-page="perPage"
                      thead-class="header"
                      class="mt-3"
                      show-empty
                      :no-border-collapse="true"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      @filtered="onFilter"
                    >
                      <template slot="empty">
                        <div v-if="isDisableRadio" class="text-center">
                          <span><b>Loading...</b></span>
                        </div>
                        <div v-else class="text-center">No data available.</div>
                      </template>
                    </b-table>
                    <b-pagination
                      style="float: right"
                      v-model="currentPage"
                      :total-rows="filterCount"
                      :per-page="perPage"
                      prev-text="Prev"
                      next-text="Next"
                      aria-controls="myHistory"
                      hide-goto-end-buttons
                    ></b-pagination>
                  </b-collapse>
                </div>
              </b-card>
            </transition>
          </div>
        </b-tab>
        <b-tab title="Orders">
          <manage-order :showData="true"></manage-order>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select";
import ManageOrder from "@/views/orders/ManageOrder.vue";
import moment from "moment";
import { mapActions } from "vuex";
import ComponentHeader from "@/components/componentHeader";
export default {
  name: "Inventory Report",
  components: {
    ebSelect,
    "manage-order": ManageOrder,
    ComponentHeader,
  },
  data() {
    return {
      loading: false,
      tabIndex: 0,
      stocksData: [],
      stockStatus: [],
      itemId: "",
      selectedStock: {},
      perPage: 9,
      disableKey: false,
      isDisableRadio: false,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      currentPage: 1,
      currentpage: 1,
      loading: false,
      dateFilterStockStatus: 1,
      dateFilterStockReport: 1,
      stockList: {},
      stockPointId: "",
      sortBy: "updatedAt",
      sortDesc: true,
      filterCount: 0,
      filtercount: 0,
      dayRadioOption: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 days",
          value: 7,
        },
        {
          text: "30 days",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      Columns: [
        {
          key: "store",
          label: "STORE",
        },
        {
          key: "itemName",
          label: "ITEM NAME",
        },
        {
          key: "numberOfOrders",
          label: "NO OF ORDERS",
        },
        {
          key: "totalQuantity",
          label: "TOTAL QUANTITY",
        },
        {
          key: "uom",
          label: "UOM",
        },
        {
          key: "ACTION",
        },
      ],
      ColumnStore: [
        {
          key: "stockingDate",
        },
        {
          key: "itemName",
        },
        {
          key: "UOM",
        },
        {
          key: "totalVolume",
        },
        {
          key: "inStockVolume",
        },
        {
          key: "wastedVolume",
        },
      ],
      Column: [
        {
          key: "stockingDate",
          sortable: true,
        },
        {
          key: "stock",
          label: "Store-Stock Point",
          sortable: true,
        },
        {
          key: "itemName",
          sortable: true,
        },
        {
          key: "UOM",
        },
        {
          key: "totalVolume",
          sortable: true,
        },
        {
          key: "inStockVolume",
          sortable: true,
        },
        {
          key: "delivered",
          sortable: true,
        },
        {
          key: "locked",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    stockOptions() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let userId = this.$store.getters["auth/getUserID"];
      if (data.length > 0) {
        let stockpoints = [];
        data.map((obj) => {
          if (obj.category == "STOCK_POINT") {
            stockpoints.push({
              _id: obj._id,
              providerId: userId,
              label: obj.office.officeName,
              ...obj,
            });
          }
        });
        stockpoints.unshift({ label: "All", _id: "all" });
        return stockpoints;
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions({
      GetStockReport: "inventory/inventoryOrderReport",
      GetStockStatus: "inventory/inventoryOrderStatus",
    }),
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    onfilter(list) {
      this.filtercount = list.length;
      this.currentpage = 1;
    },
    viewStockdetails(data) {
      this.$router.push({
        name: "viewStockDetails",
        params: { userData: data },
      });
    },
    async getStockpointList() {
      this.loading = true;
      await this.$store.dispatch("partner/fetchPartnersList").then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
          this.loading = false;
        }
        this.loading = false;
      });
    },
    getDateData(dateData) {
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment().subtract(dateData, "days").format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    getStockReportData() {
      this.loading = true;
      this.stocksData = [];
      this.GetStockReport({
        deliveryCenter: this.selectedStock._id,
        ...this.getDateData(this.dateFilterStockReport),
      }).then((res) => {
        this.loading = false;
        if (res.data.response && res.data.response.length) {
          const listData = [];
          res.data.response.map((x) => {
            x.itemDetails.map((y) => {
              listData.push({
                store: x.providerName,
                itemName: y.itemName,
                numberOfOrders: y.orderCount,
                totalQuantity: y.totalQuantity,
                providerId: x._id,
                itemId: y.itemId,
                uom: "kg",
                ...this.getDateData(this.dateFilterStockReport),
              });
            });
          });
          this.stocksData = listData;
        }
      });
    },
    getStockStatusData() {
      this.loading = true;
      this.stockStatus = [];
      this.GetStockStatus({
        deliveryCenter: this.selectedStock._id,
        ...this.getDateData(this.dateFilterStockStatus),
      }).then((res) => {
        this.loading = false;
        if (res.data.response && res.data.response.length) {
          const tableData = [];
          res.data.response.map((x) => {
            x.stockPoint.map((y) => {
              tableData.push({
                stockingDate: x.date,
                itemName: x.item.itemName,
                UOM: "kg",
                totalVolume: x.totalCount,
                inStockVolume: x.totalAvailable,
                locked: x.totalLocked + x.totalBooked,
                stock: y.name,
                delivered: x.totalDelivered,
                wastedVolume: 0
              });
            });
          });
          this.stockStatus = tableData;
        }
      });
    },
    changeDeliveryCentre() {
      this.getStockStatusData();
      this.getStockReportData();
    },
    dateRangeStockStatus(e) {
      this.dateFilterStockStatus = e;
      this.getStockStatusData();
    },
    dateRangeStockReport(e) {
      this.dateFilterStockReport = e;
      this.getStockReportData();
    },
  },
  async mounted() {
    let data = this.$store.getters["partner/GetPartnerList"];
    if (!data || !data.length) this.getStockpointList();
  },
};
</script>
